if (!customElements.get('custom-modalv2')) {
  class ModalV2 extends HTMLElement {
    constructor() {
      super();
      this.activeIds = [];
      this.activeId = null;
      this._closeTimer = null;
      this.handleKeydown = this.handleKeydown.bind(this);
      this.removeModal = this.removeModal.bind(this);
      this.observer = new MutationObserver(() => this.handleContentUpdate());
      this.searchParams = new URLSearchParams(window.location.search);
    }

    handleContentUpdate() {
      const modalId = this.activeIds[this.activeIds.length - 1];
      const elToTrap = this.querySelector(`[data-modal-content="${modalId}"]:not([data-update-focus="false"]):not(template)`);
      if (elToTrap) trapFocus(elToTrap);
    }

    animateIn(modalId = this.activeIds[this.activeIds.length - 1]) {
      const el = document.querySelector(`[data-modal-content="${modalId}"]:not(template)`);
      if (!el) return;
      el.getAnimations().forEach(a => a.cancel());
      trapFocus(el);
      el.classList.remove('modal-invisible');
      el.classList.add('modal-visible');
      ['transitioncancel', 'transitionend'].forEach(type => {
        el.addEventListener(type, () => {
          document.querySelectorAll('[data-modal-id][data-nav-item][data-hover-trigger]').forEach(el2 => {
            const id = el2.dataset.modalId;
            if (id !== this.activeId) this.close(id);
          });
        }, { once: true });
      });
    }

    animateOut(modalId) {
      const el = document.querySelector(`[data-modal-content="${modalId}"]:not(template)`);
      if (!el) return;
      clearTimeout(this._closeTimer);
      el.getAnimations().forEach(a => a.cancel());
      el.classList.add('modal-invisible');
      el.classList.remove('modal-visible');
      ['transitioncancel', 'transitionend'].forEach(type => {
        el.addEventListener(type, () => {
          el.remove();
        }, { once: true });
      });
      this._closeTimer = setTimeout(() => {
        if (!this.activeIds.length) document.body.classList.remove('nav-open', 'overlay');
      }, 301);
    }

    open(modalId, parent) {
      if (!modalId) return;
      clearTimeout(this._closeTimer);
      this.activeId = modalId;
      let existing = document.querySelector(`[data-modal-content="${modalId}"]:not(template)`);
      if (existing) {
        this.animateIn(modalId);
        document.body.classList.add('overlay');
        return;
      }
      const template = document.querySelector(`[data-modal-content="${modalId}"]`);
      if (!template) return;
      this.activeIds.push(modalId);
      const newModal = document.createElement('div');
      newModal.innerHTML = template.cloneNode(true).innerHTML;
      newModal.classList.add('modal-invisible');
      newModal.setAttribute('role', 'dialog');
      newModal.setAttribute('aria-modal', true);
      [...template.attributes].forEach(attr => newModal.setAttribute(attr.nodeName, attr.nodeValue));
      if (parent) parent.appendChild(newModal);
      else this.appendChild(newModal);
      document.body.classList.add('overlay');
      document.body.classList.toggle('no-animate-modal', document.querySelectorAll('[data-modal-content]:not(template)').length > 1);
      setTimeout(() => {
        this.animateIn(modalId);
        (function(c,e,k,l,a){
          c[e]=c[e]||{};
          for(c[e].q=c[e].q||[];a<l.length;)k(l[a++],c[e]);
        })(window,"extole",function(c,e){
          e[c]=e[c]||function(){e.q.push([c,arguments])};
        },["createZone"],0);
        window.extole.createZone({name:'global_header',element_id:'extole_zone_global_header'});
      }, 1);
      window.addEventListener('keydown', this.handleKeydown);
    }

    closeAll() {
      document.querySelectorAll('[data-modal-content]:not(template)').forEach(el => {
        this.animateOut(el.dataset.modalContent);
      });
      this.activeId = null;
      this.activeIds = [];
    }

    close(modalId = this.activeIds[this.activeIds.length - 1]) {
      const minicart = document.querySelector('mini-cart');
      const miniOpen = minicart.cartModalOpen; //For keeping overlay active if minicart is open
      if (this.activeId == modalId) this.activeId = null;
      if (this.activeIds.find(x => x === modalId)) {
        this.activeIds = this.activeIds.filter(x => x !== modalId);
        document.querySelector(`[data-modal-action="open"][data-modal-id="${modalId}"]:not([data-hover-trigger])`)?.focus();
        if (!miniOpen) this.animateOut(modalId);
        setTimeout(() => {
          
          document.body.classList.toggle('no-animate-modal', (document.querySelectorAll('[data-modal-content]:not(template)').length > 1));
          document.querySelector(`[data-modal-content="${modalId}"]:not(template)`)?.remove();
          this.classList.remove('hovered');
          if (!this.activeIds.length && !miniOpen) {
            document.body.classList.remove('nav-open', 'overlay');
          }
        }, 301);
        
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape') this.close();
    }

    removeModal(e) {
      e.target.removeEventListener('mouseleave', this.removeModal);
      document.querySelectorAll('[data-modal-content]:not(template)').forEach(el => {
        const id = el.dataset.modalContent;
        if (id === this.activeId) this.close(id);
        else {
          this.activeIds = this.activeIds.filter(x => x !== id);
          el.remove();
        }
      });
      setTimeout(() => {
        document.querySelectorAll('[data-modal-content].modal-invisible:not(template)').forEach(el => {
          const id = el.dataset.modalContent;
          this.activeIds = this.activeIds.filter(x => x !== id);
          if (id === this.activeId) this.activeId = null;
          el.remove();
        });
        if (!this.activeIds.length) {
          document.body.classList.remove('nav-open', 'overlay');
          this.classList.remove('hovered');
        }
      }, 301);
    }

    connectedCallback() {
      this.observer.observe(this, { childList: true, subtree: true });
      if (this.searchParams.get('reset')) {
        if (!window.location.pathname.includes('account')) this.open('account');
        setTimeout(() => window.dispatchEvent(new CustomEvent('login:showForm', { detail: 'forgot-pass' })), 10);
      }
      window.addEventListener('modal:openById', e => this.open(e.detail));
      window.addEventListener('modal:closeById', e => this.close(e.detail));
      window.addEventListener('mouseover', e => {
        const hovered = e.target.closest('[data-modal-action][data-hover-trigger]');
        if (!hovered) return;
        const { modalAction, modalId, navItem } = hovered.dataset;
        if (modalAction === 'open' && !this.activeIds.includes(modalId)) {
          this.classList.add('hovered');
          document.body.classList.add(navItem ? 'nav-open' : 'overlay');
          this.open(modalId, hovered);
          hovered.addEventListener('mouseleave', this.removeModal);
        }
        if (modalAction === 'close-all') this.closeAll();
      });
      window.addEventListener('click', e => {
        if (e.target.tagName.toLowerCase() === 'custom-modalv2') this.close();
        const clicked = e.target.closest('[data-modal-action]');
        if (!clicked) return;
        if (clicked.closest('[data-hover-trigger]') && document.activeElement !== clicked) return;
        const { modalAction, modalId, navItem, hoverTrigger } = clicked.dataset;
        if (modalAction === 'open') {
          if (modalId === 'account' && window.location.pathname.includes('login')) return;
          window.dispatchEvent(new CustomEvent(`modal-open:${modalId}`));
          document.body.classList.add(navItem ? 'nav-open' : 'overlay');
          if (hoverTrigger) {
            this.open(modalId, clicked);
            return;
          }
          this.open(modalId);
          if (modalId === 'search') this.querySelector('input')?.focus();
        }
        if (modalAction === 'close') this.close();
      });
    }
  }

  customElements.define('custom-modalv2', ModalV2);
}
